import clsx from 'clsx';
import { APIDealRequestStatus, APIRequestStatus } from 'api/types';

import styles from './styles.module.scss';

type RequestStatusProps = {
  status: APIRequestStatus;
};

const RequestStatus: React.FC<RequestStatusProps> = (props) => {
  const {
    status: { name, value },
  } = props;

  const variantClass = (() => {
    switch (value) {
      case APIDealRequestStatus.Opened:
        return styles.neutral;

      case APIDealRequestStatus.Active:
      case APIDealRequestStatus.Pending:
        return styles.progress;

      case APIDealRequestStatus.Closed:
        return styles.positive;

      case APIDealRequestStatus.Cancelled:
      case APIDealRequestStatus.Postponed:
        return styles.negative;
    }
  })();

  return <span className={clsx(styles.status, variantClass)}>{name}</span>;
};

export default RequestStatus;
